<template>
  <div class="breadcrumbs text-sm">
    <ul>
      <li>
        <RouterLink
          class="link"
          :to="{
            name: 'ClientExplorer',
            query: {
              ...$route.query,
              path: '',
            },
          }"
        >
          Disks
        </RouterLink>
      </li>
      <li v-for="dir in explorer_store.dirs" :key="dir.path">
        <RouterLink
          class="link"
          :to="{
            name: 'ClientExplorer',
            query: {
              ...$route.query,
              path: dir.path,
            },
          }"
        >
          {{ dir.name }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { use_explorer } from "./useExplorer";

const explorer_store = use_explorer();
</script>
